var _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileTypeCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.902 27.201-2.246-25.201h24.688l-2.249 25.197-10.11 2.803z",
    fill: "#1572b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 27.858 8.17-2.265 1.922-21.532h-10.092z",
    fill: "#33a9dc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 13.191h4.09l.282-3.165h-4.372v-3.091h.011 7.739l-.074.829-.759 8.518h-6.917z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.019 21.218-.014.004-3.442-.93-.22-2.465h-1.673-1.43l.433 4.853 6.331 1.758.015-.004z",
    fill: "#ebebeb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19.827 16.151-.372 4.139-3.447.93v3.216l6.336-1.756.047-.522.537-6.007z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ebebeb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.011 6.935v1.92 1.163.008h-7.456-.01l-.062-.695-.141-1.567-.074-.829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 13.191v1.92 1.163.008h-3.389-.01l-.062-.695-.14-1.567-.074-.829z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeCss);
export default __webpack_public_path__ + "static/media/file-type-css.d775a84d2e94cdab548cdffe1aa9ff83.svg";
export { ForwardRef as ReactComponent };